export default __webpack_public_path__ + "static/media/loading.19405d20.gif";